// extracted by mini-css-extract-plugin
export default {"grid-parent":"Bp4T3l","footer":"oa98Nv"};